<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication">This book is dedicated to my husband, Timothy B. Smith</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4page.vue?1de94040